import React from 'react'
import { withTranslation } from 'react-i18next';

const Bygg = (props) => {
    var bygg = props.bygg;
    var bygningsstatus = bygg.bygningsstatus.substr(0, bygg.bygningsstatus.indexOf(' '));    
    return(
        <li className="resultitem" onClick={() => props.onSelectResult(bygg)}>
            <div className="title">{bygg.bygningstype} - {bygningsstatus} - {bygg.bygningsnummer}</div>
        </li>
    )
  }

export default withTranslation('common')(Bygg)